import React from 'react';

export default function ContactCTA() {
  return (
    <section className="py-16 md:py-24 bg-[var(--color-bg)]">
      <div className="mx-auto max-w-[var(--container-max)] px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left: CTA Content */}
          <div className="flex flex-col justify-center">
            <div className="text-sm font-semibold text-[var(--color-accent)] uppercase tracking-wider mb-3">
              Ajánlatkérés
            </div>
            <h2 className="text-3xl md:text-5xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] tracking-tight mb-6 leading-tight">
              Kérjen ajánlatot és mi{' '}
              <span className="text-[var(--color-accent)]">48 órán belül elküldjük Önnek</span>
            </h2>
            <p className="text-lg text-[var(--color-text-secondary)] leading-relaxed mb-8">
              Keressen bennünket az alábbi elérhetőségeken és kollégáink 2 munkanapon belül felveszik Önnel a kapcsolatot. 
              Ingyenes konzultáció és 3D tervezés minden megrendeléshez.
            </p>

            {/* Contact Info */}
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white shadow-[var(--shadow-subtle)] flex items-center justify-center text-xl flex-shrink-0">
                  📞
                </div>
                <div>
                  <div className="font-semibold text-[var(--color-text-primary)] mb-1">Telefonon</div>
                  <a href="tel:06704179210" className="text-[var(--color-accent)] hover:underline text-lg">
                    06 (70) 417 9210
                  </a>
                  <p className="text-sm text-[var(--color-text-secondary)] mt-1">
                    Hétfő-Péntek: 9:00-17:00 | Szombat: 8:00-13:00
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white shadow-[var(--shadow-subtle)] flex items-center justify-center text-xl flex-shrink-0">
                  ✉️
                </div>
                <div>
                  <div className="font-semibold text-[var(--color-text-primary)] mb-1">E-mailben</div>
                  <a href="mailto:xlbutorbolt@gmail.com" className="text-[var(--color-accent)] hover:underline text-lg">
                    xlbutorbolt@gmail.com
                  </a>
                  <p className="text-sm text-[var(--color-text-secondary)] mt-1">
                    Válaszolunk 24 órán belül
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white shadow-[var(--shadow-subtle)] flex items-center justify-center text-xl flex-shrink-0">
                  📍
                </div>
                <div>
                  <div className="font-semibold text-[var(--color-text-primary)] mb-1">Személyesen</div>
                  <p className="text-[var(--color-text-secondary)]">
                    Kisvárda, Attila u. 61, 4600
                  </p>
                  <p className="text-sm text-[var(--color-text-secondary)] mt-1">
                    Üzletünkben és műhelyünkben
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Email Guide */}
          <div>
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-[var(--shadow-md)]">
              <div className="flex items-center gap-3 mb-6">
                <span className="text-3xl">💬</span>
                <h3 className="text-2xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)]">
                  Mit írjon az emailben?
                </h3>
              </div>

              <div className="space-y-6">
                <p className="text-[var(--color-text-secondary)] leading-relaxed">
                  Hogy minél pontosabb ajánlatot tudjunk adni, kérjük adja meg az alábbi információkat:
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <span className="text-[var(--color-accent)] font-bold flex-shrink-0">1.</span>
                    <div>
                      <p className="font-semibold text-[var(--color-text-primary)] mb-1">Az Ön neve és elérhetősége</p>
                      <p className="text-sm text-[var(--color-text-secondary)]">Hogy vissza tudjunk hívni</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="text-[var(--color-accent)] font-bold flex-shrink-0">2.</span>
                    <div>
                      <p className="font-semibold text-[var(--color-text-primary)] mb-1">Milyen helyiségbe készül a bútor?</p>
                      <p className="text-sm text-[var(--color-text-secondary)]">Pl. konyha, nappali, hálószoba</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="text-[var(--color-accent)] font-bold flex-shrink-0">3.</span>
                    <div>
                      <p className="font-semibold text-[var(--color-text-primary)] mb-1">Rövid leírás az elképzelésről</p>
                      <p className="text-sm text-[var(--color-text-secondary)]">Milyen bútorra van szüksége, milyen stílusban</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="text-[var(--color-accent)] font-bold flex-shrink-0">4.</span>
                    <div>
                      <p className="font-semibold text-[var(--color-text-primary)] mb-1">Méretek (ha van)</p>
                      <p className="text-sm text-[var(--color-text-secondary)]">Szélesség, magasság, mélység</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <span className="text-[var(--color-accent)] font-bold flex-shrink-0">5.</span>
                    <div>
                      <p className="font-semibold text-[var(--color-text-primary)] mb-1">Tervrajz vagy képek (opcionális)</p>
                      <p className="text-sm text-[var(--color-text-secondary)]">Csatolhatja az emailhez</p>
                    </div>
                  </div>
                </div>

                <div className="pt-6 border-t border-gray-200">
                  <p className="text-sm text-[var(--color-text-secondary)] mb-4">
                    💡 <strong>Tipp:</strong> Minél részletesebb információt ad, annál pontosabb ajánlatot tudunk készíteni!
                  </p>

                  <a
                    href="mailto:xlbutorbolt@gmail.com?subject=Ajánlatkérés - Egyedi bútor&body=Név:%0D%0ATelefonszám:%0D%0A%0D%0AHelyiség:%0D%0A%0D%0ALeírás:%0D%0A%0D%0AMéretek:%0D%0A"
                    className="block w-full px-8 py-4 bg-[var(--color-accent)] text-white font-semibold rounded-lg hover:bg-[var(--color-accent-hover)] transition-all duration-300 shadow-md hover:shadow-lg text-center"
                  >
                    ✉️ Email küldése most
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
